import { axiosInstance } from "@/api/apiClient";
import {
  CallQueueApi,
  CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest,
  CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest,
  CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest,
  CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new CallQueueApi(undefined, BASE_API, axiosInstance);

export const getAgentCallQueues = async (
  payload: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest
) => {
  return api.telephonyViewsNinjaCallCallQueueListAgentCallQueues.bind(api)(
    payload
  );
};

export const getAgentCallQueueItems = async (
  payload: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest
) => {
  return api.telephonyViewsNinjaCallCallQueueListAgentCallQueueItems.bind(api)(
    payload
  );
};

export const getCallQueues = async (
  payload: CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest
) => {
  return api.telephonyViewsNinjaCallCallQueueListCallQueues.bind(api)(payload);
};

export const reorderCallQueueItem = async (
  payload: CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest
) => {
  return api.telephonyViewsNinjaCallCallQueueReorderCallQueueItem.bind(api)(
    payload
  );
};
